module.exports = __webpack_public_path__ + "static/media/affiliate_banner_mobile_2x.2d806009.webp";